/**
 * 大兜底的symbol列表，包含BTC/USDT、ETH/USDT
 * 用于处理symbolList接口请求失败且本地缓存为空的情况
 * 以下注释的代表v1版本有，v2版本已删除的字段
 */

var SYMBOLS = {
  quoteTokenResult: [{
    // orgId: 9001,
    // token: null,
    tokenId: 'USDT',
    tokenName: 'USDT',
    tokenFullName: null,
    // iconUrl: 'https://s1.bycsi.com/app/assets/token/3e732ebdfde20dfe151e1f60bba8e545.svg',
    // iconDayUrl: 'https://s1.bycsi.com/app/assets/token/170314b1e124e4f11ac58e456264a1b7.svg',
    // customOrder: 1,
    // status: null,
    // isTest: false,
    // baseTokenSymbols: [],
    quoteTokenSymbols: [{
      // orgId: 9001,
      // exchangeId: 301,
      // exchangeName: null,
      symbolId: 'BTCUSDT',
      symbolName: 'BTCUSDT',
      baseTokenId: 'BTC',
      baseTokenName: 'BTC',
      quoteTokenId: 'USDT',
      quoteTokenName: 'USDT',
      basePrecision: '0.000001',
      quotePrecision: '0.00000001',
      minTradeQuantity: '0.000048',
      minTradeAmount: '1',
      minPricePrecision: '0.01',
      digitMerge: '100,10,1,0.1,0.01',
      // canTrade: true,
      // favorite: null,
      // customOrder: 11,
      // indexShow: null,
      // indexShowOrder: null,
      // baseTokenOption: null,
      // baseTokenFutures: null,
      // baseTokenMargin: null,
      // firstLevelUnderlyingId: null,
      // firstLevelUnderlyingName: null,
      // secondLevelUnderlyingId: null,
      // secondLevelUnderlyingName: null,
      // indexToken: null,
      // isReverse: null,
      // isAggregate: false,
      // indexRecommendOrder: 0,
      showStatus: true,
      // category: 1,
      // allowMargin: false,
      // labelId: 0,
      label: null,
      // symbolTag: null,
      // symbolConfig: null,
      allowPlan: true,
      maxTradeQuantity: '71.73956243',
      maxTradeAmount: '4000000',
      noticeVisible: false,
      symbolType: 'CHAIN_TOKEN',
      ltUnderlying: '',
      ltDirection: '',
      tags: ['BTC Ecosystem', 'PoW', 'Margin Trading'],
      tokenFullName: 'Bitcoin',
      iconUrl: 'https://s1.bycsi.com/app/assets/token/62942131f968981af06a885a79f864ba.svg',
      onlineTime: 0,
      mark: [],
      quoteTokenLeverageRatio: '5',
      baseTokenLeverageRatio: '5',
      loanEnabled: true,
      // isTest: false,
      isBanBuy: false,
      isBanSell: false,
      iconDayUrl: 'https://s1.bycsi.com/app/assets/token/d9c8c35b4223b50d9773d7d5294d019f.svg',
      tradeStatus: 3,
      zeroFeeType: 0,
      limitOrderPriceLimitPercentage: 3,
      marketOrderPriceLimitPercentage: 3,
      volume: '45176669677.585138660000000000'
    }, {
      // orgId: 9001,
      // exchangeId: 301,
      // exchangeName: null,
      symbolId: 'ETHUSDT',
      symbolName: 'ETHUSDT',
      baseTokenId: 'ETH',
      baseTokenName: 'ETH',
      quoteTokenId: 'USDT',
      quoteTokenName: 'USDT',
      basePrecision: '0.00001',
      quotePrecision: '0.0000001',
      minTradeQuantity: '0.00062',
      minTradeAmount: '1',
      minPricePrecision: '0.01',
      digitMerge: '100,10,1,0.1,0.01',
      // canTrade: true,
      // favorite: null,
      // customOrder: 10,
      // indexShow: null,
      // indexShowOrder: null,
      // baseTokenOption: null,
      // baseTokenFutures: null,
      // baseTokenMargin: null,
      // firstLevelUnderlyingId: null,
      // firstLevelUnderlyingName: null,
      // secondLevelUnderlyingId: null,
      // secondLevelUnderlyingName: null,
      // indexToken: null,
      // isReverse: null,
      // isAggregate: false,
      // indexRecommendOrder: 0,
      showStatus: true,
      // category: 1,
      // allowMargin: false,
      // labelId: 0,
      label: null,
      // symbolTag: null,
      // symbolConfig: null,
      allowPlan: true,
      maxTradeQuantity: '1229.2336343',
      maxTradeAmount: '4000000',
      noticeVisible: false,
      symbolType: 'CHAIN_TOKEN',
      ltUnderlying: '',
      ltDirection: '',
      tags: ['ETH Ecosystem', 'Margin Trading'],
      tokenFullName: 'Ethereum',
      iconUrl: 'https://s1.bycsi.com/app/assets/token/35a48e2a91411dcdb00c7fdd443676a9.svg',
      onlineTime: 0,
      mark: [],
      quoteTokenLeverageRatio: '5',
      baseTokenLeverageRatio: '5',
      loanEnabled: true,
      // isTest: false,
      isBanBuy: false,
      isBanSell: false,
      iconDayUrl: 'https://s1.bycsi.com/app/assets/token/8f413d7ed51fa4bc3d206d6abf41f4dc.svg',
      tradeStatus: 3,
      zeroFeeType: 0,
      limitOrderPriceLimitPercentage: 3,
      marketOrderPriceLimitPercentage: 3,
      volume: '24752207274.164747600000000000'
    }],
    quoteTags: ['0 Fees', 'Adventure Zone', 'SOL Ecosystem', 'ETH Ecosystem', 'BTC Ecosystem', 'AI', 'Modular-BCs', 'DePIN', 'LSD', 'DeFi', 'GameFi', 'Inscriptions', 'Meme', 'PoW', 'Stablecoin', 'Innovation Zone', 'ETP (Leveraged Tokens)', 'Margin Trading', 'Launchpool', 'Launchpad'],
    tokenType: 'CHAIN_TOKEN',
    zeroFeeType: 0
  }],
  version: ''
};
export default SYMBOLS;